<template>
  <BForm @submit.stop.prevent="onSubmit">
    <slot />
  </BForm>
</template>

<script setup lang="ts">
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { onBeforeUnmount, onMounted, watch } from "vue";
import { computed } from "vue";
import store from "@/store";
import { OVERLAY_KEYBOARD } from "@/utils/constants";
const overlayKeyBoard = computed(() => store.state.keyBoard.enter);

const emit = defineEmits(["on:submit"]);
const props = defineProps({
  show: { type: Boolean, default: false },
  enterEvent: { type: Boolean, default: false },
});

watch(
  () => props.show,
  (value) => watchShow(value),
);
onMounted(() => watchShow(props.show));
onBeforeUnmount(() => reset());

const watchShow = (value) => {
  if (value) initial();
  else reset();
};

const initial = () => {
  if (overlayKeyBoard.value === OVERLAY_KEYBOARD.MODAL) {
    if (props.enterEvent)
      EventEmitter.on(EmitterEvents.EVENT_KEYBOARD_ENTER, onSubmit);
  } else {
    reset();
  }
};

const reset = () => {
  if (props.enterEvent) EventEmitter.off(EmitterEvents.EVENT_KEYBOARD_ENTER);
};

const onSubmit = () => emit("on:submit");
</script>
